import { AfterViewInit, Directive, ElementRef, OnChanges, Renderer2, SimpleChanges, input } from '@angular/core';

@Directive({
  selector: '[ngfBadge]',
})
export class BadgeDirective implements AfterViewInit, OnChanges {

  readonly COUNTER_LIMIT = 99;

  public count = input<number | string>(0, { alias: 'ngfBadge' });

  public hidden = input<boolean>(false, { alias: 'ngfBadgeHidden' });

  private badgeRef: any = null;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit(): void {
    this.renderer.addClass(this.el.nativeElement, 'ngf-badge-container');
    const badgeEl = this.renderer.createElement('span');
    this.hideBadge(badgeEl, this.hidden());
    this.renderer.addClass(badgeEl, 'ngf-badge');
    this.updateText(badgeEl);

    this.renderer.appendChild(this.el.nativeElement, badgeEl);
    this.badgeRef = badgeEl;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.badgeRef) {
      return;
    }

    if (changes.hasOwnProperty('hidden')) {
      const { hidden } = changes;
      if (hidden.previousValue !== hidden.currentValue) {
        this.hideBadge(this.badgeRef, hidden.currentValue);
      }
    }

    if (changes.hasOwnProperty('count')) {
      const { count } = changes;
      if (count.previousValue !== count.currentValue) {
        this.updateText(this.badgeRef);
      }
    }
  }

  private hideBadge(ref: any, hide: boolean): void {
    if (hide) {
      this.renderer.addClass(ref, 'ngf-badge-hidden');
    } else {
      this.renderer.removeClass(ref, 'ngf-badge-hidden');
    }
  }

  private updateText(ref: any): void {
    if (this.count() != null) {
      const count = this.count();
      if (typeof count === 'string') {
        ref.innerText = count;
      } else if (count <= 0) {
        ref.innerText = '';
      } else {
        ref.innerText = count > this.COUNTER_LIMIT
          ? this.COUNTER_LIMIT
          : count;
      }
    }
  }
}
